import React from 'react';

const ProjectIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.90625 0.9104C2.2494 0.9104 0.90625 2.25355 0.90625 3.9104V18.3974C0.90625 20.0543 2.2494 21.3974 3.90625 21.3974H18.3933C20.0501 21.3974 21.3933 20.0543 21.3933 18.3974V6.99157C21.3933 5.33471 20.0501 3.99157 18.3933 3.99157H12.1498C11.835 3.99157 11.5386 3.84337 11.3498 3.59157L10.2389 2.1104C9.67231 1.35498 8.78315 0.9104 7.83888 0.9104H3.90625ZM2.90625 3.9104C2.90625 3.35812 3.35397 2.9104 3.90625 2.9104H7.83888C8.15363 2.9104 8.45002 3.05859 8.63888 3.3104L9.74975 4.79157C10.3163 5.54698 11.2055 5.99157 12.1498 5.99157H18.3933C18.9455 5.99157 19.3933 6.43928 19.3933 6.99157V18.3974C19.3933 18.9497 18.9455 19.3974 18.3933 19.3974H3.90625C3.35397 19.3974 2.90625 18.9497 2.90625 18.3974V3.9104ZM12.1502 8.84289C12.1502 8.29061 11.7024 7.84289 11.1502 7.84289C10.5979 7.84289 10.1502 8.29061 10.1502 8.84289V16.5458C10.1502 17.0981 10.5979 17.5458 11.1502 17.5458C11.7024 17.5458 12.1502 17.0981 12.1502 16.5458V8.84289ZM14.2315 10.9242C14.7838 10.9242 15.2315 11.3719 15.2315 11.9242V16.5459C15.2315 17.0982 14.7838 17.5459 14.2315 17.5459C13.6792 17.5459 13.2315 17.0982 13.2315 16.5459V11.9242C13.2315 11.3719 13.6792 10.9242 14.2315 10.9242ZM9.06886 14.2347C9.06886 13.6824 8.62114 13.2347 8.06886 13.2347C7.51657 13.2347 7.06886 13.6824 7.06886 14.2347V16.5456C7.06886 17.0979 7.51657 17.5456 8.06886 17.5456C8.62114 17.5456 9.06886 17.0979 9.06886 16.5456V14.2347Z"
      fill="#28B0E1"
    />
  </svg>
);

export default ProjectIcon;
